import React from 'react';
import { LibraryHeader } from './LibraryHeader';
import { LibraryView } from './LibraryView';
import { HeartIcon, SearchIcon } from 'lucide-react';
export const Sidebar = () => {
  const libraryItems = [{
    id: '1',
    title: 'Liked Songs',
    subtitle: 'Playlist • 673 songs',
    imageUrl: 'https://misc.scdn.co/liked-songs/liked-songs-64.png',
    type: 'playlist'
  }, {
    id: '2',
    title: 'Infections Of A Different Kind – Step 1',
    subtitle: 'Album • AURORA',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02fb13ebe958ca179eb115789c',
    type: 'album'
  }, {
    id: '3',
    title: 'Mayte González',
    subtitle: 'Artist',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5eb8ae7f2aaa9817a704a87ea98',
    type: 'artist'
  }, {
    id: '4',
    title: 'GoGo Penguin',
    subtitle: 'Album • GoGo Penguin',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02fb13ebe958ca179eb115789c',
    type: 'album'
  }, {
    id: '5',
    title: 'How I AI',
    subtitle: 'Podcast • Claire Vo',
    imageUrl: 'https://i.scdn.co/image/ab6765630000ba8a83f27e617bd40304c0d1c16a',
    type: 'podcast'
  }, {
    id: '6',
    title: 'La Garfield',
    subtitle: 'Artist',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5eb8ae7f2aaa9817a704a87ea98',
    type: 'artist'
  }, {
    id: '7',
    title: "Lenny's Podcast: Product | Growth | Career",
    subtitle: 'Podcast • Lenny Rachitsky',
    imageUrl: 'https://i.scdn.co/image/ab6765630000ba8a83f27e617bd40304c0d1c16a',
    type: 'podcast'
  }, {
    id: '8',
    title: 'Cyberpunk Dystopia',
    subtitle: 'Playlist • Synthetic',
    imageUrl: 'https://i.scdn.co/image/ab67706c0000da84c37f51f4b8df2d7c02d1f1f9',
    type: 'playlist'
  }, {
    id: '9',
    title: 'Dream Theater',
    subtitle: 'Artist',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5eb8ae7f2aaa9817a704a87ea98',
    type: 'artist'
  }, {
    id: '10',
    title: 'It Happened Quiet',
    subtitle: 'AURORA',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02fb13ebe958ca179eb115789c',
    type: 'song'
  }];
  const filterOptions = [{
    id: 'playlists',
    label: 'Playlists'
  }, {
    id: 'artists',
    label: 'Artists'
  }, {
    id: 'albums',
    label: 'Albums'
  }, {
    id: 'podcasts',
    label: 'Podcasts & Shows'
  }];
  return <div className="flex flex-col h-full bg-[#121212] w-[280px] text-white" data-id="element-60">
      <div className="p-6" data-id="element-61">
        <img src="https://storage.googleapis.com/pr-newsroom-wp/1/2018/11/Spotify_Logo_RGB_White.png" alt="Spotify" className="h-10 mb-6" data-id="element-62" />
        <div className="space-y-4 mb-6" data-id="element-63">
          <div className="flex items-center gap-4 font-bold text-white" data-id="element-64">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-65">
              <path d="M12.5 3.247a1 1 0 0 0-1 0L4 7.577V20h4.5v-6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6H20V7.577l-7.5-4.33zm-2-1.732a3 3 0 0 1 3 0l7.5 4.33a2 2 0 0 1 1 1.732V21a1 1 0 0 1-1 1h-6.5a1 1 0 0 1-1-1v-6h-3v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.577a2 2 0 0 1 1-1.732l7.5-4.33z" data-id="element-66"></path>
            </svg>
            <span data-id="element-67">Home</span>
          </div>
          <div className="flex items-center gap-4 text-[#b3b3b3]" data-id="element-68">
            <SearchIcon size={24} data-id="element-69" />
            <span data-id="element-70">Search</span>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-71">
        <div className="px-2" data-id="element-72">
          <div className="flex items-center justify-between mb-4" data-id="element-73">
            <div className="flex items-center gap-2 text-[#b3b3b3] p-2" data-id="element-74">
              <svg height="24" width="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-75">
                <path d="M3 22a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v18a1 1 0 0 1-1 1zM15.5 2.134A1 1 0 0 0 14 3v18a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6.464a1 1 0 0 0-.5-.866l-6-3.464zM9 2a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1z" data-id="element-76"></path>
              </svg>
              <span className="font-bold" data-id="element-77">Your Library</span>
            </div>
            <div className="flex items-center gap-2 text-[#b3b3b3]" data-id="element-78">
              <button className="p-2 hover:text-white" data-id="element-79">
                <svg height="16" width="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-80">
                  <path d="M15.25 8a.75.75 0 0 1-.75.75H8.75v5.75a.75.75 0 0 1-1.5 0V8.75H1.5a.75.75 0 0 1 0-1.5h5.75V1.5a.75.75 0 0 1 1.5 0v5.75h5.75a.75.75 0 0 1 .75.75z" data-id="element-81"></path>
                </svg>
              </button>
              <button className="p-2 hover:text-white" data-id="element-82">
                <svg height="16" width="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-83">
                  <path d="M7.19 1A.749.749 0 0 1 8.47.47L16 7.99l-7.53 7.521a.75.75 0 0 1-1.234-.815.75.75 0 0 1 .174-.243l5.72-5.714H.75a.75.75 0 1 1 0-1.498h12.38L7.41 1.529a.749.749 0 0 1-.22-.53z" data-id="element-84"></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="flex gap-2 mb-4 px-2" data-id="element-85">
            {filterOptions.map(option => <button key={option.id} className="px-3 py-1 text-sm rounded-full border border-[#727272] text-white hover:border-white" data-id="element-86">
                {option.label}
              </button>)}
          </div>
          <div className="flex items-center justify-between px-2 mb-2" data-id="element-87">
            <button className="p-2 text-[#b3b3b3] hover:text-white" data-id="element-88">
              <SearchIcon size={16} data-id="element-89" />
            </button>
            <button className="p-2 text-[#b3b3b3] hover:text-white flex items-center gap-1" data-id="element-90">
              <span className="text-sm" data-id="element-91">Recents</span>
              <svg height="16" width="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-92">
                <path d="M15 14.5H5V13h10v1.5zm0-5.75H5v-1.5h10v1.5zM15 3H5V1.5h10V3zM3 3H1V1.5h2V3zm0 5.75H1v-1.5h2v1.5zm0 5.75H1V13h2v1.5z" data-id="element-93"></path>
              </svg>
            </button>
          </div>
          <div className="space-y-2" data-id="element-94">
            {libraryItems.map(item => <div key={item.id} className="flex items-center gap-3 p-2 hover:bg-[#242424] rounded" data-id="element-95">
                <div className="w-12 h-12 flex-shrink-0" data-id="element-96">
                  <img src={item.imageUrl} alt={item.title} className={`w-full h-full object-cover ${item.type === 'playlist' && item.title === 'Liked Songs' ? 'bg-gradient-to-br from-[#450af5] to-[#c4efd9]' : ''}`} data-id="element-97" />
                </div>
                <div className="min-w-0" data-id="element-98">
                  <div className="text-white text-sm font-medium truncate" data-id="element-99">
                    {item.title}
                  </div>
                  <div className="text-[#b3b3b3] text-xs truncate" data-id="element-100">
                    {item.subtitle}
                  </div>
                </div>
                {item.type === 'song' && <button className="ml-auto p-1" data-id="element-101">
                    <svg height="16" width="16" viewBox="0 0 16 16" fill="#1DB954" data-id="element-102">
                      <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z" data-id="element-103"></path>
                      <path d="M8 3.25a.75.75 0 0 1 .75.75v3.25H11a.75.75 0 0 1 0 1.5H7.25V4A.75.75 0 0 1 8 3.25z" data-id="element-104"></path>
                    </svg>
                  </button>}
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};